import React from 'react';
import { t } from '@lingui/macro';
import styled from 'styled-components';

import Close from '@rover/icons/svg/close.svg';
import { Button, Flex } from '@rover/kibble/core';
import FocusOutlineStyle from '@rover/kibble/styles/FocusOutlineStyle';

interface WrapperProps {
  highlighted?: boolean;
}

const Wrapper = styled.li<WrapperProps>`
  align-items: center;
  background: ${({ theme }) => theme.background.tertiary};
  border-radius: ${({ theme }) => theme.radii.secondary};
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  height: 26px;
  line-height: 27px;
  margin: 5px ${({ theme }) => theme.space['1x']};
  padding-left: ${({ theme }) => theme.space['2x']};
  white-space: nowrap;
  ${(props) => props.highlighted && FocusOutlineStyle()}
`;

const StyledClose = styled(Close)`
  height: 13px;
  width: 13px;
`;

const handleIconClick = (
  { webEvent }: { webEvent?: React.MouseEvent<HTMLElement> },
  onClickIcon
): void => {
  webEvent?.stopPropagation();
  onClickIcon();
};

export type Props = {
  onClickIcon: () => void;
  ariaLabel?: string;
  highlighted?: boolean;
  id?: string;
  role?: React.AriaRole;
  children: React.ReactNode;
};

const SelectionButton: React.FC<Props> = ({
  onClickIcon,
  ariaLabel,
  highlighted,
  role,
  id,
  children,
}: Props) => {
  return (
    <Flex
      webAs={Wrapper}
      background="tertiary"
      borderRadius="secondary"
      paddingLeft="2x"
      alignItems="center"
      // @ts-expect-error this is a pretty non-standard usage of Flex + webAs, it works but types are unhappy, not worth fixing now
      highlighted={highlighted}
      id={id || ''}
      webProps={{
        role,
      }}
      aria-label={ariaLabel || t`Remove Option`}
      aria-selected
    >
      {children}
      <Button
        sx={{ ':hover': { background: 'tertiary' } }}
        variant="flat"
        onPress={(events): void => handleIconClick(events, onClickIcon)}
        icon={StyledClose}
        mr="2x"
        ml="1x"
        size="small"
        p="1x"
        webProps={{
          'aria-label': ariaLabel || t`Remove Option`,
        }}
      />
    </Flex>
  );
};

export default SelectionButton;
